var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2093 1H13.7907C18.8419 1 21 3.15814 21 8.2093V13.7907C21 18.8419 18.8419 21 13.7907 21H8.2093C3.15814 21 1 18.8419 1 13.7907V8.2093C1 3.15814 3.15814 1 8.2093 1ZM13.7907 19.6047C18.0791 19.6047 19.6047 18.0791 19.6047 13.7907V8.2093C19.6047 3.92093 18.0791 2.39535 13.7907 2.39535H8.2093C3.92093 2.39535 2.39535 3.92093 2.39535 8.2093V13.7907C2.39535 18.0791 3.92093 19.6047 8.2093 19.6047H13.7907Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82564 7.0185C10.0024 7.0185 10.1791 7.08362 10.3187 7.22315L13.6024 10.5069C13.8721 10.7766 13.8721 11.2232 13.6024 11.4929L10.3187 14.7767C10.0489 15.0464 9.60238 15.0464 9.33261 14.7767C9.06285 14.5069 9.06285 14.0604 9.33261 13.7906L12.1233 10.9999L9.33261 8.2092C9.06285 7.93943 9.06285 7.49292 9.33261 7.22315C9.46285 7.08362 9.63959 7.0185 9.82564 7.0185Z",
    fill: "#292D32",
    stroke: "#292D32",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.42caf0dea342b7b4d7ae47e916e58ae9.svg";
export { ForwardRef as ReactComponent };